/**
 * components/MobilManageModal.js
 * Modal for merge ("Gabung") and rename ("Ubah nama") car operations.
 * Props: { mode: "merge" | "rename", car, cars, onSubmit, onClose }
 */
import React, { useState } from "react";
import { useModalEsc, backdropClose } from "../utils/modalStack";

export default function MobilManageModal({ mode, car, cars, onSubmit, onClose }) {
  const [value, setValue] = useState(mode === "rename" ? car : "");

  useModalEsc(onClose);

  const otherCars = (cars || []).filter((c) => c.name.toLowerCase() !== (car || "").toLowerCase());

  const canSubmit = mode === "rename"
    ? value.trim() !== "" && value.trim().toLowerCase() !== (car || "").toLowerCase()
    : value !== "";

  const handleSubmit = () => {
    if (!canSubmit) return;
    onSubmit(mode === "rename" ? value.trim() : value);
  };

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" onMouseDown={backdropClose(onClose)}>
      <div className="modal-box" onMouseDown={(e) => e.stopPropagation()}>
        {mode === "rename" ? (
          <>
            <h2 className="modal-title">Ubah nama mobil</h2>
            <div className="form-row" style={{ marginTop: "var(--gap-lg)" }}>
              <label className="form-label" htmlFor="mobil-manage-nama-baru">Nama baru</label>
              <input id="mobil-manage-nama-baru" className="form-input" autoFocus value={value}
                onChange={(e) => setValue(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter" && canSubmit) { e.preventDefault(); handleSubmit(); } }}
              />
              {/* Disabled-control sweep (manual-testing report): two distinct reasons Simpan can
                  be disabled — blank gets the shared "Wajib diisi." convention; typing the exact
                  current name back is a different, less obvious reason and gets its own message
                  (mutually exclusive by construction — trim()==="" can't also equal `car`'s own
                  non-empty name). */}
              {value.trim() === "" && <div className="form-hint" style={{ color: "var(--red)" }}>Wajib diisi.</div>}
              {value.trim() !== "" && value.trim().toLowerCase() === (car || "").toLowerCase() && (
                <div className="form-hint" style={{ color: "var(--red)" }}>Nama baru harus berbeda dari nama sekarang.</div>
              )}
            </div>
          </>
        ) : (
          <>
            <h2 className="modal-title">Gabung ke mobil lain</h2>
            <p className="page-sub" style={{ marginBottom: "var(--gap-lg)" }}>
              Semua barang yang memakai "<b>{car}</b>" akan diubah ke mobil yang dipilih.
            </p>
            <div className="form-row">
              <label className="form-label" htmlFor="mobil-manage-gabung-ke">Gabungkan ke</label>
              <select id="mobil-manage-gabung-ke" className="form-select" value={value} onChange={(e) => setValue(e.target.value)}>
                <option value="">— Pilih mobil —</option>
                {otherCars.map((c) => (
                  <option key={c.name} value={c.name}>{c.name}</option>
                ))}
              </select>
            </div>
          </>
        )}
        <div className="modal-actions">
          <button type="button" className="btn" onClick={onClose}>Batal</button>
          <button type="button" className="btn btn-primary" disabled={!canSubmit} onClick={handleSubmit}>
            {mode === "rename" ? "Simpan" : "Gabung"}
          </button>
        </div>
      </div>
    </div>
  );
}
